<template>
  <div class="sub-navigation">
    <container>
      <div class="sub-navigation__content">
        <ul>
          <template v-for="(item, index) in items">
            <li :key="index">
              <router-link :to="item.to">
                {{ item.title }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'

export default {
  name: 'NavList',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Container
  }
}
</script>

<style lang="stylus" scoped>
  .sub-navigation
    background #ffffff
    border-bottom 1px solid #dee2e6

    &__content
      ul
        list-style none
        margin 0
        padding 0

        li
          display inline-block

          a
            display flex
            flex-flow row wrap
            align-items center
            padding 15px 10px
            color #222
            text-transform uppercase
            font-weight 700
            text-decoration none
            position relative
            border-radius 3px

            &:before
              content ""
              width 100%
              height 0px
              position absolute
              bottom 0
              left 0
              transition height 0.2s ease-in-out

            &:not(:hover)
              &:before
                transition height 0.2s ease-in-out

            &:hover
              &:before
                background #ccc
                height 2px
                transition height 0.2s ease-in-out

            &.router-link-exact-active
              &:before
                background #423799
                height 2px
</style>



// WEBPACK FOOTER //
// SubNavigation.vue?8fd37b2c